import { Box, Container, Grid, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { UserForm } from "shared/customer/UserForm"
const AddUser = ({ match }) => {
  const [customerResult, customerApi] = useApi()
  const [suggestPasswordResult, suggestPasswordApi] = useApi()
  const [addUserResult, addUserApi] = useApi()
  const [emptyUserResult, getEmptyUser] = useApi()
  const loadingContext = useContext(GlobalLoaderContext)
  const routerHistory = useHistory()
  const { t } = useTranslation()

  useEffect(() => {
    // efter skapa success, redirecta till listan
    if (addUserResult.status === 2)
      routerHistory.push(allRoutes.SystemadminCustomersEditUsers(match.params.id))
  }, [addUserResult.status, routerHistory, match])

  useEffect(() => {
    const loadStuff = async () => {
      getEmptyUser.get(apiEndpoints.systemadmincustomers.getemptyuser.replace("{id}", match.params.id))

      customerApi.get(apiEndpoints.systemadmincustomers.getcustomerbyid.replace("{id}", match.params.id))
      suggestPasswordApi.get(apiEndpoints.util.getpasswordsuggestion)
    }

    loadStuff()
  }, [match, customerApi, suggestPasswordApi])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  const handleSubmit = (objectToSave) => {
    addUserApi.post(apiEndpoints.systemadmincustomers.adduser, objectToSave)
  }

  const feedback = {
    errorTitle: "Användare kunde inte skapas"
  }

  // id = customerId

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminCustomersEditUsers(match.params.id),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid item container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{t("settings.user.add_user", "Add user")}</Typography>
          </Grid>
        </Box>

        {customerResult.status === 2 && suggestPasswordResult.status === 2 ? (
          <UserForm
            passwordSuggestEndpoint={apiEndpoints.util.getpasswordsuggestion}
            suggestedPassword={suggestPasswordResult.data}
            customer={customerResult.data}
            onSubmit={handleSubmit}
            result={addUserResult}
            feedback={feedback}
            parentIsSysAdmin={true}
            initialValues={emptyUserResult.data}
            addUser={true}
          />
        ) : null}
      </Container>
    </div>
  )
}
export default AddUser
